
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import PasswordMixin from '@/mixins/PasswordMixin';
import LoadingMixin from '@/mixins/LoadingMixin';

@Component
export default class Login extends mixins(LoadingMixin, PasswordMixin) {
  username = '';
  password = '';
  codeID = '';
  email = '';
  remember = false;
  revealPassword = false;
  showForgot = false;
  isLoading = false;
  CodeRespon: number | null = null; // Inisialisasi dengan null atau 0

  mounted() {
    this.codeID = new URL(window.location.href).searchParams.get('reset') || '';

    // Jika `reset` parameter tidak ada atau kosong, alihkan ke halaman login
    if (!this.codeID) {
      this.$router.push({name: 'login'});
    } else {
      this.onResetPassword(); // Panggil fungsi reset password jika parameter ada
    }
  }

  get appName() {
    return process.env.VUE_APP_NAME;
  }
  get rules() {
    return {
      username: 'required',
      password: 'required',
    };
  }

  onLoginClik() {
    this.$router.push({name: 'login'});
  }

  async onResetPassword() {
    this.isLoading = true;
    this.startLoading();
    this.codeID = new URL(window.location.href).searchParams.get('reset') || '';
    try {
      const Respon = await this.$store.dispatch('auth/resetPassword', {
        code: this.codeID,
      });
      this.CodeRespon = Respon.code ? Respon.code : 200;
      // Jika respon dari API adalah 404, alihkan ke halaman login
      if (this.CodeRespon === 404) {
        this.$router.push({name: 'login'});
      }
    } catch (error) {
      // Handle network or unexpected errors
      this.showForgot = false;
      this.$alert.error('Terjadi kesalahan jaringan');
    } finally {
      this.finishLoading();
      this.isLoading = false;
      this.showForgot = false;
    }
  }
}
